import { useState } from 'react'
import {
  readStoredDashboardDateRange,
  writeStoredDashboardDateRange
} from 'utils/dateRangeFilters'

export const useDashboardDateRange = (defaultDate) => {
  const [dateRange, setDateRangeState] = useState(() => readStoredDashboardDateRange(defaultDate))

  const setDateRange = (nextRange) => {
    setDateRangeState(nextRange)
    writeStoredDashboardDateRange(nextRange)
  }

  return [dateRange, setDateRange]
}
